<template>
  <div class="entrance-header">
    <img class="top-title" :src="HeaderImg" />
    <div class="tabs">
      <div
        v-for="(tab, index) in tabs" 
        :key="tab.name || index"
        class="tab"
        :class="{ 'tab-active': tab.actived }"
        @click="handleTabClick(tab)"
      >
        <span class="multiply">×</span>
        <span class="num">{{ tab.name?.replace(/^x/, '') || '' }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

// 获取当前语言
const { locale } = useI18n();

import img1 from '../img/hall-cover/topTitle CN.webp'
import img2 from '../img/hall-cover/topTitle EN.webp'
const HeaderImg = computed(() => {
  if (locale.value == 'cn') {
    return img1
  } else {
    return img2
  }
})

const props = defineProps<{
  tabs: any[];  
  tabName:string
}>();
const emit = defineEmits<{
  tabChange: [index: number]
}>()

// 处理tab点击事件
const handleTabClick = (tab: any) => {
  emit('tabChange', tab)
}
</script>

<style scoped>
/* 样式保持不变 */
.entrance-header {
  padding: 0 0.5rem 0.75rem;
}

.top-title {
  width: 100%;
  height: auto;
}

.tabs {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  margin-top: -0.938rem;

  .tab {
    height: 2rem;
    border-radius: 0.5rem;
    padding: 0 1rem;
    background: #1C2532;
    border: 0.063rem solid #55657E;
    display: flex;
    align-items: center;
    gap: 0.125rem;
    box-sizing: border-box;
    color: white;
    cursor: pointer;

    /* 添加平滑过渡动画 */
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    /* 悬停效果 - 只保留阴影，移除缩放 */
    &:hover {
      box-shadow: 0 0.25rem 0.75rem rgba(60, 26, 234, 0.3);
    }

    /* 移除了空的 active 规则集以修复 lint 警告 */

    .multiply {
      font-weight: 600;
      font-size: 0.875rem;
      line-height: 0.875rem;
      letter-spacing: 0.031rem;
    }

    .num {
      font-weight: 800;
      font-size: 1.25rem;
      line-height: 1.25rem;
      letter-spacing: 0.031rem;
    }
  }

  .tab-active {
    background: #3C1AEA;
    border: 0.063rem solid #18FFD9;
    /* 激活状态只保持颜色变化，不加阴影，不变大 */
    /* 移除了空的 hover 和 active 规则集以修复 lint 警告 */
  }
}
</style>